import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import examManage from './modules/examManage'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    examManage,
  },
})
